<template>
  <div>
    <van-popup
      title="会员卡支付"
      v-model="sShow"
      position="bottom"
      @close="onClose"
    >
      <div class="f-cl b-s p-t-30 h-100%">
        <div>
          <div class="tc font-50">
            <span>￥</span>
            <span>{{ recAmount }}</span>
          </div>
          <div class="font-22 tc m-t-20">请输入支付密码</div>
          <div class="passWord">
            <div
              v-for="(v, i) in keyPass"
              :key="i"
              class="pass"
              :class="{ active: keyNum + 1 === i }"
            >
              <div v-if="keyNum >= i" class="f-ar h-80 l-h-80">
                <g-img
                  :src="require('@/assets/images/pwd_show.png')"
                  size="40"
                  top="10"
                ></g-img>
              </div>
            </div>
          </div>
          <div class="tc m-tb-20">
            <!-- <g-btn
              t="免密支付"
              @click="noSecret"
            ></g-btn> -->
            <van-button color="var(--tc)" size="small" @click="noSecret"
              >免密支付</van-button
            >
          </div>
        </div>

        <div class="nonSecretPaymentKeyboard">
          <div v-for="(v, i) in keyBoardList" :key="i" class="item">
            <div class="sureKey" v-if="v === '确认'" @click="onSurePay">
              {{ v }}
            </div>
            <div v-else class="otherKey" @click="keyBoardNum(v)">
              {{ v }}
            </div>
          </div>
          <div class="deleteKey" @click="deleteNum">
            <g-img
              :src="require('@/assets/images/delete_key@2x.png')"
              size="40"
              top="10"
            ></g-img>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "NonSecretPay",
  props: {
    show: {
      type: Boolean,
      default: false,
      default: true,
    },
    recAmount: {
      type: [String, Number],
      default: ".99",
    },
    list: {
      type: Object,
      default: () => {},
    },

    orderId: {
      type: [String, Number],
      default: "",
    },
    memberGuid: {
      type: [String, Number],
      default: "",
    },
    lstPayed: {
      type: Array,
      default: () => [],
    },
    lstTicketId: {
      type: [String, Number],
      default: "",
    },
    lstConsumeWaternum: {
      type: [String, Number],
      default: "",
    },
    lstLeaveKey: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    show(val) {
      this.sShow = val;
    },
  },
  data() {
    return {
      sShow: this.show,
      keyNum: -1,
      keyPass: ["", "", "", "", "", ""],
      keyBoardList: [1, 2, 3, 4, 5, 6, 7, 8, 9, "确认", 0],
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    deleteNum() {
      if (this.keyNum > -1) {
        this.keyPass[this.keyNum] = "";
        this.keyNum--;
      }
    },
    onClose() {
      this.$emit("update:show", false);
    },
    noSecret() {
      this.postPayRequest("free");
    },
    keyBoardNum(v) {
      if (this.keyNum < 5) {
        this.keyNum++;
        this.keyPass[this.keyNum] = v;
      }
      if (this.keyNum === 5) {
        this.postPayRequest();
      }
    },
    onSurePay() {
      if (this.keyPass.join("").length < 6) {
        return this.$toast("请输入完整密码");
      }
      this.postPayRequest();
    },

    postPayRequest(flag) {
      const { list } = this;
      let mOrderId = this.$store.state.orderId;
      if(!mOrderId){
        mOrderId = this.orderId
      }
      let params = {
        OrderId: mOrderId,
        MemberPayments: [
          {
            MemberId: list.Id, // 会员账户id
            ConsumeMoney: this.recAmount, // 会员支付金额
            CardTypeId: list.CardTypeId, // 会员卡种id
            RowVersion: list.RowVersion, // 数据版本标识
            CardCode: list.CardCode,
            CardTypeName: list.CardTypeName,
            Password: flag == "free" ? "" : this.keyPass.join(""),
          },
        ],
      };
      $http("wechath5/zh-cn/v1/member/pay", params, "post").then((res) => {
        console.log("44444333<<<  res  >>>44444");
        console.log(res);
        this.$emit("paySuccess", res);
        // location.href = location.href.split('#')[0] + '#/consumecode-detail/' + res;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.active {
  box-shadow: 0 0 15px var(--tc);
}
.nonSecretPaymentKeyboard {
  border-top: 1px solid #cfcfcf;
  width: 100%;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  justify-content: center;
  .sureKey {
    width: 100%;
    height: 100%;
    line-height: 90px;
    text-align: center;
    background: #d4d8db;
    border-bottom: none;
  }
  .otherKey {
    width: 100%;
    height: 100%;
    line-height: 90px;
    text-align: center;
  }
  .item {
    border-right: 1px solid #e7e7e7;
  }
  .item,
  .deleteKey {
    width: 33.33%;
    height: 90px;
    line-height: 90px;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-bottom: 1px solid #e7e7e7;
  }
  :nth-child(3n) {
    border-right: none;
  }
}
.passWord {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 38px auto 10px;
  .pass {
    width: 80px;
    height: 100%;
    margin-right: 10px;
    border: 1px solid #aaa;
  }
}
</style>
